export default __webpack_public_path__ + "static/media/img--interiors-6.b14257d4.jpg";